module.exports = __webpack_public_path__ + "static/media/maisner.db3cfa5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/maisner.png
// module id = 332
// module chunks = 0